import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ShieldOffOutline = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("g", {
    "data-name": "Layer 2",
    key: "k0"
  }, React.createElement("g", {
    "data-name": "shield-off"
  }, React.createElement("path", {
    d: "M4.71 3.29a1 1 0 00-1.42 1.42l16 16a1 1 0 001.42 0 1 1 0 000-1.42zM12.3 19.68l-.3.17-.3-.17A13.15 13.15 0 015 8.23v-.14L5.16 8 3.73 6.56A2 2 0 003 8.09v.14a15.17 15.17 0 007.72 13.2l.3.17a2 2 0 002 0l.3-.17a15.22 15.22 0 003-2.27l-1.42-1.42a12.56 12.56 0 01-2.6 1.94zM20 6.34L13 2.4a2 2 0 00-2 0L7.32 4.49 8.78 6 12 4.15l7 3.94v.14a13 13 0 01-1.63 6.31L18.84 16A15.08 15.08 0 0021 8.23v-.14a2 2 0 00-1-1.75z"
  }))));
});
ShieldOffOutline.displayName = 'ShieldOffOutline';
export var ShieldOffOutlineDimensions = {
  height: 20,
  width: 20
};